import { render, staticRenderFns } from "./QuotationDetailTable.vue?vue&type=template&id=c327d088&scoped=true&"
import script from "./QuotationDetailTable.vue?vue&type=script&lang=js&"
export * from "./QuotationDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./QuotationDetailTable.vue?vue&type=style&index=0&id=c327d088&lang=less&scoped=true&"
import style1 from "./QuotationDetailTable.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c327d088",
  null
  
)

export default component.exports